<template>
  <div class="container">
    <h3 class="h3_title">{{ $t("management.faqManagement") }}</h3>
    <div class="commTop_btn_wrap" style="text-align: right">
      <div class="btn_wrap fR p-2">
        <router-link
          type="button"
          to="/management/support/faq/form"
          class="btn btn-primary btn-md m-2"
          >{{ $t("common.add") }}</router-link
        >
        <button type="button" @click="showFaqModal" class="btn btn-secondary btn-md">
          {{ $t("common.changeOrder") }}
        </button>
      </div>
    </div>
    <div class="faq_list_wrap">
      <span v-for="(faq, index) in faqList" :key="index">
        <h3 class="acc_trigger" :id="faq.boardId">
          <a href="javascript:void(0)" @click="showFaq(faq.boardId)"
            ><span>Q</span>{{ faq.title }}</a
          >
        </h3>
        <div class="acc_container" style="display: none">
          <span>A</span>
          <div v-html="faq.content" class="fap_block"></div>
          <router-link
            :to="{ name: 'mgmtFaqForm', params: { boardId: faq.boardId } }"
            class="btn btn-primary btn-sm"
            >{{ $t("common.edit") }}</router-link
          >
          <button
            type="button"
            @click="deleteFaq(faq)"
            class="btn btn-secondary btn-sm m-1"
          >
            {{ $t("common.delete") }}
          </button>
        </div>
      </span>
    </div>

    <CommonModal id="faqModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("common.changeOrder") }}</h3>
      </template>
      <template slot="body">
        <draggable v-model="faqList" @end="checkMove">
          <transition-group>
            <div class="order-box" v-for="faq in faqList" :key="faq.sort">
              <p>{{ faq.title }}</p>
            </div>
          </transition-group>
        </draggable>
      </template>
      <template slot="footer">
        <button type="button" @click="saveNewSort" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </div>
</template>

<script>
import $ from "jquery";
import { getFaqList, saveNewFaqSort, deleteFaq } from "@/api/faq";
import CommonModal from "@/components/modal/CommonModal";
import draggable from "vuedraggable";

export default {
  components: {
    CommonModal,
    draggable,
  },
  data() {
    return {
      faqList: [],
      boardId: "",
      categoryList: [],
      myArray: [],
      confirmYN: false,
      showModal: false,
    };
  },
  created() {
    this.fetchData();
    $(".acc_container").hide();
  },
  methods: {
    async fetchData() {
      try {
        const response = await getFaqList();
        this.faqList = response.data.faqList;
        console.log(this.faqList);
      } catch (err) {
        console.log(err);
      }
    },
    showFaq(boardId) {
      if (
        $("#" + boardId)
          .next()
          .is(":hidden")
      ) {
        //If immediate next container is closed...
        $(".acc_trigger").removeClass("active").next().slideUp(); //Remove all .acc_trigger classes and slide up the immediate next container
        $("#" + boardId)
          .toggleClass("active")
          .next()
          .slideDown(); //Add .acc_trigger class to clicked trigger and slide down the immediate next container
        // open 된 faq 를 재클릭할 경우 닫힘
      } else if ($("#" + boardId).hasClass("active")) {
        $("#" + boardId)
          .removeClass("active")
          .next()
          .slideUp();
      }
      return false; //Prevent the browser jump to the link anchor
    },
    showFaqModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    checkMove() {},
    async saveNewSort() {
      this.conformYN = confirm(this.$t("alert.save"));
      if (this.conformYN) {
        try {
          const { data } = await saveNewFaqSort(this.faqList);
          if (data.status) {
            alert(this.$t("alert.changedSuccessfully"));
            this.showModal = false;
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
    async deleteFaq(faq) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteFaq(faq);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped>
.faqModal {
  border-bottom: 1px;
}
.faqModal :hover {
  background: rgba(0, 0, 0, 0.075);
}
</style>
